class ContractsController {

	constructor(ContractsService) {
		'ngInject';
		this.contractsService = ContractsService;
		this.contractHTML = '';
		this.typeOfContracts = ['onlineContract','generalContract','dataContract','bankSecrecyContract']
	}

	$onInit() {

		if(this.typeOfContracts.includes(this.type)){

			this.fetchContractHTML(this.type);

		}
	}

	determineClass(){
		return (this.type == 'bankSecrecyContract')? "contract-terms bank-secrecy":'contract-terms';
	}


	fetchContractHTML(type){

		this.contractsService[type]()
			.then(response => {
				this.contractHTML = response.data.content.rendered;
			})
	}

}

export default ContractsController;
